





























import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from '@vue/composition-api';
import { DiscourseProperties } from '@oare/types';
import sl from '@/serviceLocator';
import PropertyCardUnit from './PropertyCardUnit.vue';

export default defineComponent({
  name: 'DiscoursePropertiesCard',
  props: {
    discourseUuid: {
      type: String,
      required: true,
    },
  },
  components: {
    PropertyCardUnit,
  },
  setup(props) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const loading = ref(false);

    const properties = ref<DiscourseProperties>();

    const displayCard = computed(() => {
      const hasProperties =
        properties.value && properties.value.properties.length > 0;
      const hasNotes = properties.value && properties.value.notes.length > 0;

      return hasProperties || hasNotes;
    });

    onMounted(async () => {
      try {
        loading.value = true;
        properties.value = await server.getDiscourseProperties(
          props.discourseUuid
        );
      } catch (err) {
        actions.showErrorSnackbar(
          'Error loading discourse properties',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    });

    return {
      properties,
      displayCard,
      loading,
    };
  },
});
